import { lazy } from 'react';

export const LazyDropboxConfirmStorageAccessPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--dropbox-confirm-storage-access-page" */ './dropbox-confirm-storage-access-page'
    ),
);
